import { Metamodel } from 'app/model/base/model';
import { AmazonS3WriteSettings } from './amazon-s3-store-write-settings';
import { GoogleCloudStorageLinkedService } from 'app/model/linkedservice/google-cloud-storage.linkedservice';

@Metamodel.model({
    name: 'GoogleCloudStorageWriteSettings',
    tags: {
        linkedServiceModel: Metamodel.modelFor(GoogleCloudStorageLinkedService)
    }
})
export class GoogleCloudStorageWriteSettings extends AmazonS3WriteSettings {
}
